<template>
    <div>
        <h3 class="text-2xl text-dark mb-4 font-bold">
            Highest Rated Tyres
        </h3>

        <p class="mb-4">The most popular tyres as voted by our users</p>

        <TransitionGroup mode="in-out" name="list">
            <div class="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-8" v-if="!loading">
                <TyreCard v-for="product of products" :product="product"></TyreCard>
            </div>

            <div v-else class="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-8">
                <TyreCardLoader :items="6"></TyreCardLoader>
            </div>
        </TransitionGroup>
    </div>
</template>

<script setup>
import TyreCard from "@/Components/Products/Tyres/TyreCard";
import TyreCardLoader from "@/Components/Loaders/TyreCardLoader";
import {onMounted, ref} from "vue";

let products = ref([]);
let loading = ref(false);

const getTyres = async () => {
    loading.value = true;

    const response = await axios.get(route("products.highest"));

    loading.value = false;
    products.value = response.data;
};

onMounted(() => getTyres());
</script>

<style scoped>

</style>
